module.exports = __webpack_public_path__ + "img/b53e428.png";